import { Dropdown, Select } from 'antd'
import { ItemType } from 'antd/es/menu/interface';
import moment from 'moment-timezone';
import React, { FC } from 'react'

interface Props {
    borderBold?: boolean;
    riderMenuOptions: ItemType[] | undefined;
    riderItem: any;
    additionalColumns: any;
    handleCheckBoxRiderItemChange: (e: any, riderId?: string) => void;
    fromSignsPolicy?: boolean;
}

const RiderItem: FC<Props> = ({borderBold, riderMenuOptions, riderItem, additionalColumns, handleCheckBoxRiderItemChange, fromSignsPolicy }) => {




    const getSeenRider = () => {
        let loggedUser: any = localStorage.getItem('loggedUser');
        const userData = loggedUser ? JSON.parse(loggedUser) : {}

        if (riderItem.riderStatusType == 3 && riderItem.underwriterUserId == userData.id)
            return true;
        return false
    }

    const calcRiderPremia = () => {
        let totalPremia = 0;
        if (riderItem.payments && riderItem.payments.length > 0) {
            riderItem.payments.forEach((payment: any) => {
                totalPremia += payment.amount || 0;
            });
        }
        return totalPremia.toFixed(2);
    }

    const disableCheckbox = () => {
        if (riderItem.riderStatusType == 3 && riderItem.hasShlomoPackages === true) {
            return false;
        }
        return true;
    }

    return (
        <Dropdown menu={{ items: riderMenuOptions }} trigger={['contextMenu']}>
            <div className={`sing-details-row ${getSeenRider() ? 'unseen' : ''}`} /*onClick={(e: any) => onRiderRowClick(e)}*/
            style={{ border: borderBold && borderBold === true ? '3px solid #017bfd78' : '3px solid #b2afafed' }}>
                    <div className="row-cell client-name" title='שם'>
                        <div className="description cell-value" style={{fontWeight: 'bold'}}>
                            {riderItem.customer && riderItem.customer.fullName}
                        </div>
                    </div>
                    <div className={`row-cell client-id ${!additionalColumns || !additionalColumns.includes("ת.ז.") ? 'hide' : ''}`} title='תז/חפ'>
                        <div className="description cell-value">
                            {riderItem.customer && riderItem.customer.identifier}
                        </div>
                    </div>
                    <div className={`row-cell production ${!additionalColumns || !additionalColumns.includes("סוג הפקה")  ? 'hide' : ''}`} title='הפקה'>
                        <div className="description cell-value">
                            ידנית
                        </div>
                    </div>
                    <div className="row-cell insurance-company" title='חברת ביטוח'>
                        <div className="description cell-value">
                            {riderItem.supplier}
                        </div>
                    </div>
                    <div className="row-cell policy-type" title='סוג פוליסה'>
                        <div className="description cell-value flex-start">
                            <div className="icon policy-type road-services"></div>
                            שרותי דרך
                        </div>
                    </div>
                    <div className="row-cell route-id" title='ענף'>
                        <div className="description cell-value">
                        </div>
                    </div>
                    <div className={`row-cell route-name`} title='מסלול'>
                        <div className="description cell-value">

                        </div>
                    </div>
                    <div className="row-cell insurance" title='ביטוח'>
                        <div className="description cell-value">
                            שרותי דרך
                        </div>
                    </div>
                    <div className="row-cell premia" title={`פרמיה`}>
                        <div className="description cell-value">
                            ₪{calcRiderPremia()}
                        </div>
                    </div>
                    <div className="row-cell event" title='אירוע'>
                        <div className="description cell-value">
                            {riderItem.additionNumber == null || riderItem.additionNumber == 0 ? <>חדש</> : <>חידוש</>}
                        </div>
                    </div>
                    <div className="row-cell license-id" title='הנכס'>
                        <div className="description cell-value">
                            {riderItem.vehicle && riderItem.vehicle.licenseNumber}
                        </div>
                    </div>
                    <div className="row-cell policy-number" title='מס פוליסה '>
                        <div className="description cell-value">
                            {/* subscriberNumber */}
                            {riderItem.subscriberNumber}
                        </div>
                    </div>
                    <div className="row-cell signDate" title='תאריך יצירה '>
                        <div className="description cell-value">
                            {riderItem.createdDate ? <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                                <span>{moment(riderItem.createdDate).format('DD-MM-YYYY')}</span>
                                <span style={{ color: 'gray', marginRight: '20px' }}>{moment(riderItem.createdDate).format('HH:mm')}</span>
                            </div> : <></>}
                        </div>
                    </div>
                    <div className="row-cell alertDate" title='תאריך סיום'>
                        <div className="description cell-value">
                            {riderItem.endDate ? <>
                                {moment(riderItem.startDate).format('DD-MM-YYYY')}
                            </> : <></>}
                        </div>
                    </div>
                    <div className="row-cell prod-hours" title='שעת יעד להפקה'>
                        <div className="description cell-value">

                        </div>
                    </div>

                    <div className="row-cell creator" title='חתמת'>
                        <div className="description cell-value">
                            {riderItem.underwriterUser ? <>{riderItem.underwriterUser.fullName}</> : <></>}
                            {/* {signingItem.policy && signingItem.policy.user ?
                                <>{signingItem.policy.user.fullName}</> :
                                <></>} */}
                        </div>
                    </div>
                    <div className="row-cell creator" title='נוצר ע"י'>
                        <div className="description cell-value">
                             
{riderItem.handler ? <>{riderItem.handler.fullName}</> : <></>}
                            {/* {signingItem.elementaryPolicy && signingItem.elementaryPolicy.creatorUser ?
                                <>{signingItem.elementaryPolicy.creatorUser.fullName}</> :
                                <></>} */}
                        </div>
                    </div>
                    <div className={`row-cell checkBox-cell`} title={`הפקה`}>
                        <div className="description cell-value">
                            <input type='checkbox' className='pointer checkbox' checked={riderItem.riderStatusType === 0} disabled={disableCheckbox()}
                                    onChange={(e: any) => {
                                        if(fromSignsPolicy && fromSignsPolicy === true){
                                            console.log('fromSignsPolicy - onChange checkbox rider')
                                            handleCheckBoxRiderItemChange( e, riderItem.id)
                                        } else {
                                            handleCheckBoxRiderItemChange( e)
                                        }

                                    }} 
                                    />
                        </div>
                    </div>
                    <div className={`row-cell checkBox-cell`} title='גביה'>
                        <div className="description cell-value">
                            <input type='checkbox' className='pointer checkbox' checked={riderItem.payments && riderItem.payments.length > 0 && riderItem.payments.some((payment: any) => payment.paymentStatus === 1)}
                                disabled={disableCheckbox()} />
                        </div>
                    </div>
                    <div className={`row-cell checkBox-cell ${!additionalColumns || !additionalColumns.includes("מיגון") ? 'hide' : ''}`} title='מיגון'>
                        <div className="description cell-value">
                        </div>
                    </div>
                    <div className={`row-cell checkBox-cell ${!additionalColumns || !additionalColumns.includes("ה. תביעות") ? 'hide' : ''}`} title='ה. תביעות'>
                        <div className="description cell-value">
                        </div>
                    </div>
                    <div className={`row-cell checkBox-cell ${!additionalColumns || !additionalColumns.includes("מסמכים") ? 'hide' : ''}`} title='מסמכים'>
                        <div className="description cell-value">
                        </div>
                    </div>
                    <div className={`row-cell checkBox-cell ${!additionalColumns || !additionalColumns.includes("שליחה") ? 'hide' : ''}`} title='שליחה'>
                        <div className="description cell-value">
                        </div>
                    </div>
                    <div className="row-cell icon-comment" title='comment'>
                        <div className="description cell-value">

                        </div>
                    </div>
                    <div className="row-cell status" title='סטטוס'>
                        <div className="description cell-value">
                            <Select
                                value={riderItem.riderStatusType.toString()}
                                style={{ width: '140px' }}
                                options={[

                                    {
                                        label: 'פעיל',
                                        value: '0'
                                    },
                                    {
                                        label: 'מוקפא',
                                        value: '1'
                                    },
                                    {
                                        label: 'ביטול',
                                        value: '2'
                                    },
                                    {
                                        label: 'עוד לא פעיל',
                                        value: '3'
                                    },
                                    {
                                        label: 'בוטל טרם הפקה',
                                        value: '4'
                                    },
                                    {
                                        label: 'לא נרשם בממסי',
                                        value: '5'
                                    },
                                    {
                                        label: 'לא בתוקף',
                                        value: '6'
                                    }
                                ]}
                                disabled={true}
                                onChange={(value) => console.log('value', value)}
                            />
                        </div>
                    </div>
                    {/* <div className="cell status" title='סטטוס'>
                                <div className="description cell-value">
                                    {riderItem.RiderStatusLabel}
                                </div>
                            </div> */}
                    <div className={`row-cell creator ${!additionalColumns || !additionalColumns.includes("סוכן") ? 'hide' : ''}`} title='סוכן'>
                        <div className="description cell-value">

                        </div>
                    </div>
                    <div className={`row-cell creator ${!additionalColumns || !additionalColumns.includes("קבוצת לקוחות") ? 'hide' : ''}`} title='קבוצת לקוחות'>
                        <div className="description cell-value">

                        </div>
                    </div>
                    <div className="row-cell actions">
                        <Dropdown menu={{ items: riderMenuOptions }}>
                            <div className="act-btn-icon icon menu-hamburger pointer"></div>
                        </Dropdown>
                    </div>

            </div>
        </Dropdown>
    )
}

export default RiderItem